module.exports = __webpack_public_path__ + "static/media/covid19-popup-en-mobile.f0ce7f38.png";